export const moduloUm = [
    {
        "id": "1",
        "arquivo": "Mercado Pago_Mercado Financeiro_Parte I_v2.pdf",
        "path": "./Mercado Pago_Mercado Financeiro_Parte I_v2.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Mercado Pago_Mercado Financeiro_Parte II_1.pdf",
        "path": "./Mercado Pago_Mercado Financeiro_Parte II_1.pdf",
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Treinamento.pdf",
        "path": "./Treinamento.pdf",
        "type": "pdf"
    },
    {
        "id": "4",
        "arquivo": "Estruturacao de Fundos_Aplicacao em Aula.pdf",
        "path": "./Estruturacao de Fundos_Aplicacao em Aula.pdf",
        "type": "pdf"
    },
    {
        "id": "5",
        "arquivo": "FIDC-Lamina-v.diagramada.pdf",
        "path": "./FIDC-Lamina-v.diagramada.pdf",
        "type": "pdf"
    },
    {
        "id": "6",
        "arquivo": "LAMINA MULTIMERCADO.pdf",
        "path": "./LAMINA MULTIMERCADO.pdf",
        "type": "pdf"
    },
    {
        "id": "7",
        "arquivo": "Regulamento FIDC.pdf",
        "path": "./Regulamento FIDC.pdf",
        "type": "pdf"
    },
    {
        "id": "8",
        "arquivo": "Regulamento Multimercado.pdf",
        "path": "./Regulamento Multimercado.pdf",
        "type": "pdf"
    },
    {
        "id": "9",
        "arquivo": "Mercado Pago_Mercado Financeiro_Derivativos.pdf",
        "path": "./Mercado Pago_Mercado Financeiro_Derivativos.pdf",
        "type": "pdf"
    },
    {
        "id": "10",
        "arquivo": "Derivativos.xlsx",
        "path": "./Derivativos.xlsx",
        "type": "xlsx"
    },
    {
        "id": "11",
        "arquivo": "cotas securitizacao.xlsx",
        "path": "./cotas securitizacao.xlsx",
        "type": "xlsx"
    },
    {
        "id": "12",
        "arquivo": "Mercado Pago_Mercado Financeiro_Resumo.pdf",
        "path": "./Mercado Pago_Mercado Financeiro_Resumo.pdf",
        "type": "pdf"
    },
]

export const moduloDois = [
    {
        "id": "1",
        "arquivo": "C2P_Módulo2.pdf",
        "path": "./C2P_Modulo2.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "demonstracao_financeira_MPB_062025_FINAL.pdf",
        "path": "./demonstracao_financeira_MPB_062025_FINAL.pdf",
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Exemplo.xlsx",
        "path": "./Exemplo.xlsx",
        "type": "pdf"
    },
    {
        "id": "4",
        "arquivo": "JPM_DemonstracoesConsolidadas_IFRS.pdf",
        "path": "./JPM_DemonstracoesConsolidadas_IFRS.pdf",
        "type": "pdf"
    },
]

export const moduloTres = [
    {
        "id": "1",
        "arquivo": "Gestão de Risco.pdf",
        "path": "./Gestao de Risco.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Derivativos_Sadia.xlsx",
        "path": "./Derivativos_Sadia.xlsx",
        "type": "xlsx"
    },
]

export const moduloQuatro = [
    {
        "id": "1",
        "arquivo": "Módulo RM - parte 1.pdf",
        "path": "./Modulo RM - parte 1.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Dados para exercícios - parte 01.xlsx",
        "path": "./Dados para exercicios - parte 01.xlsx",
        "type": "xlsx"
    },
    {
        "id": "3",
        "arquivo": "LC de RM - 01.pdf",
        "path": "./LC de RM - 01.pdf",
        "type": "xlsx"
    },
    {
        "id": "4",
        "arquivo": "Quiz 01 - Risco de Mercado - Conceitos Introdutórios",
        "path": "https://forms.office.com/r/5u3r0z9TUt",
        "type": "link"
    },
    {
        "id": "5",
        "arquivo": "LC de RM - 02.pdf",
        "path": "./LC de RM - 02.pdf",
        "type": "xlsx"
    },
    {
        "id": "6",
        "arquivo": "Quiz 02 - Conceitos Matemáticos e Estatísticos",
        "path": "https://forms.office.com/r/ihq5FnmpvY",
        "type": "link"
    },
    {
        "id": "7",
        "arquivo": "Módulo RM - parte 2.pdf",
        "path": "./Modulo RM - parte 2.pdf",
        "type": "arquivo"
    },
    {
        "id": "8",
        "arquivo": "LC de RM - 03.pdf",
        "path": "./LC de RM - 03.pdf",
        "type": "arquivo"
    },
    {
        "id": "9",
        "arquivo": "Quiz 03 - Estimativa Volatilidade",
        "path": "https://forms.office.com/r/kjTzNyvVwY",
        "type": "link"
    },
    {
        "id": "10",
        "arquivo": "LC de RM - 04.pdf",
        "path": "./LC de RM - 04.pdf",
        "type": "arquivo"
    },
    {
        "id": "11",
        "arquivo": "Quiz 04 - Introdução Opções",
        "path": "https://forms.office.com/r/VaAzJGQnPg",
        "type": "link"
    },
    {
        "id": "12",
        "arquivo": "LC de RM - 05",
        "path": "./LC de RM - 05.pdf",
        "type": "arquivo"
    },
    {
        "id": "13",
        "arquivo": "Quiz 05 - BS e RF",
        "path": "https://forms.office.com/r/vF0aC3kTHQ",
        "type": "link"
    },
    {
        "id": "14",
        "arquivo": "Módulo RM - parte 3",
        "path": "./Modulo RM - parte 3.pdf",
        "type": "arquivo"
    },
    {
        "id": "15",
        "arquivo": "LC de RM - 06",
        "path": "./LC de RM - 06.pdf",
        "type": "arquivo"
    },
    {
        "id": "16",
        "arquivo": "Quiz 06 - HEDGE",
        "path": "https://forms.office.com/r/s3wg7LgJYq",
        "type": "link"
    },
    {
        "id": "17",
        "arquivo": "LC de RM - 07",
        "path": "./LC de RM - 07.pdf",
        "type": "arquivo"
    },
    {
        "id": "18",
        "arquivo": "Quiz 07 - VaR",
        "path": "https://forms.office.com/r/qBTSxtC1Ev",
        "type": "link"
    },
    {
        "id": "19",
        "arquivo": "Módulo RM - Estudo de Caso",
        "path": "./Modulo RM - Estudo de Caso.pdf",
        "type": "arquivo"
    },
]

export const moduloCinco = [
    {
        "id": "1",
        "arquivo": "Risco de Liquidez.pdf",
        "path": "./Risco de Liquidez.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Quiz 01",
        "path": "https://forms.office.com/r/eQX7iXsskf",
        "type": "link"
    },
    {
        "id": "3",
        "arquivo": "Estudo de Caso.pdf",
        "path": "./Estudo de Caso.pdf",
        "type": "pdf"
    },
    {
        "id": "4",
        "arquivo": "LA VAR.xls",
        "path": "./LA VAR.xls",
        "type": "xls"
    },
    {
        "id": "5",
        "arquivo": "Estudo de Caso Resolvido.pdf",
        "path": "./Estudo de Caso Resolvido.pdf",
        "type": "pdf"
    },
]

export const moduloSeis = [
    {
        "id": "1",
        "arquivo": "RC - parte 1.pdf",
        "path": "./RC - parte 1.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "LC de RC - 01.pdf",
        "path": "./LC de RC - 01.pdf",
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Quiz 01 - Introdução ao Risco de Crédito",
        "path": "https://forms.office.com/r/sxsr887u6p",
        "type": "link"
    },
    {
        "id": "4",
        "arquivo": "LC de RC - 02.pdf",
        "path": "./LC de RC - 02.pdf",
        "type": "pdf"
    },
    {
        "id": "5",
        "arquivo": "RC - formato c2p - parte 2.pdf",
        "path": "./RC - formato c2p - parte 2.pdf",
        "type": "pdf"
    },
    {
        "id": "6",
        "arquivo": "Quiz de RC - 02",
        "path": "https://forms.office.com/r/xy8XnvzLBJ",
        "type": "link"
    },
    {
        "id": "7",
        "arquivo": "RC - formato c2p - parte 3.pdf",
        "path": "./RC - formato c2p - parte 3.pdf",
        "type": "pdf"
    },
    {
        "id": "8",
        "arquivo": "Quiz de RC - 03",
        "path": "https://forms.office.com/r/LX6mYHNwqw",
        "type": "link"
    },
    {
        "id": "9",
        "arquivo": "Quiz de RC - 05",
        "path": "https://forms.office.com/r/qfq7iBheTm",
        "type": "link"
    },
    {
        "id": "10",
        "arquivo": "RC - formato c2p - parte 4",
        "path": "./RC - formato c2p - parte 4.pdf",
        "type": "pdf"
    },
    {
        "id": "11",
        "arquivo": "Quiz de RC - 06",
        "path": "https://forms.office.com/r/Qpedv9YG5f",
        "type": "link"
    },
]

export const moduloSete = [
    {
        "id": "1",
        "arquivo": "LC Contraparte - 01.pdf",
        "path": "./LC Contraparte - 01.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "RC Contraparte - parte 1.pdf",
        "path": "./RC Contraparte - parte 1.pdf",
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Quiz – Introdução ao Risco de Crédito de Contraparte",
        "path": "https://forms.office.com/r/dJp8cBR5qU",
        "type": "link"
    },
]